import type { TConstraints } from '@feathr/rachis';

import { EIntegrationTypes } from '../integrations';
import type { CampaignClass } from '.';
import type { TPublisherPlatforms } from './facebook';
import type { ITTDCampaignAttributes } from './ttd_base';
import { TTDCampaign } from './ttd_base';

export type TOmniIntegration = EIntegrationTypes.Tradedesk | EIntegrationTypes.Meta;

export interface IMetaSettings {
  page_id: string;
  publisher_platforms: TPublisherPlatforms[];
  special_ad_category: 'NONE' | 'HOUSING' | 'EMPLOYMENT' | 'FINANCIAL_PRODUCTS_SERVICES';
}

// Pixl Plus
export interface IOmniCampaignAttributes extends ITTDCampaignAttributes {
  readonly _cls: CampaignClass.Omni;
  integrations?: TOmniIntegration[];
  meta_settings?: IMetaSettings;
}

export class OmniCampaign extends TTDCampaign<IOmniCampaignAttributes> {
  public override get constraints(): TConstraints<IOmniCampaignAttributes> {
    return {
      ...super.constraints,
      integrations: {
        presence: {
          allowEmpty: false,
          message: '^Select at least one channel to proceed',
        },
      },
      meta_settings: {
        requiredFields: {
          unless: (attributes) => !attributes.integrations?.includes(EIntegrationTypes.Meta),
          fields: {
            page_id: {
              message: '^Meta requires selecting a Facebook page',
            },
            publisher_platforms: {
              message: '^Meta requires selecting publisher platforms',
            },
            special_ad_category: {
              message: '^Meta requires selecting a special ad category',
            },
          },
        },
      },
    };
  }

  public override getDefaults(): Partial<IOmniCampaignAttributes> {
    return {
      ...super.getDefaults(),
    };
  }
}
